var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
var cls = classNames('chat-auto-message-button');
export var ChatAutoMessageButtonDefaultProps = {
  color: 'light'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    border-radius: ", ";\n    text-align: center;\n    padding: ", " ", ";\n    font-size: 0.9em;\n    cursor: pointer;\n    font-family ", ";\n\n    ", "\n\n    &:focus {\n      border-color: ", ";\n      outline: 1px solid ", ";\n    }\n\n    &:hover {\n      color: ", ";\n      background-color: ", ";\n    }\n  "], ["\n    ", ";\n    border-radius: ", ";\n    text-align: center;\n    padding: ", " ", ";\n    font-size: 0.9em;\n    cursor: pointer;\n    font-family ", ";\n\n    ", "\n\n    &:focus {\n      border-color: ", ";\n      outline: 1px solid ", ";\n    }\n\n    &:hover {\n      color: ", ";\n      background-color: ", ";\n    }\n  "])), theme.REMOVE_BUTTON_STYLE(), theme.UNIT(4), theme.UNIT(2), theme.UNIT(4), theme.FONT('sans'), function (_a) {
    var _color = _a._color;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border: 1px solid ", ";\n      color: ", ";\n    "], ["\n      border: 1px solid ", ";\n      color: ", ";\n    "])), theme.COLOR(_color !== null && _color !== void 0 ? _color : 'bright'), theme.COLOR(_color !== null && _color !== void 0 ? _color : 'bright'));
  }, theme.HOVER_COLOR('primary', 0.2), theme.HOVER_COLOR('primary', 0.2), theme.COLOR('strong'), theme.COLOR('bright'))
});
// -------- Components -------->
var My = {
  Container: styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var ChatAutoMessageButton = function (props) {
  var className = props.className,
    children = props.children,
    onClick = props.onClick,
    color = props.color;
  return React.createElement(My.Container, {
    _color: color,
    onClick: onClick,
    className: cls.name(className)
  }, children);
};
ChatAutoMessageButton.cls = cls;
ChatAutoMessageButton.defaultProps = ChatAutoMessageButtonDefaultProps;
var templateObject_1, templateObject_2, templateObject_3;